import { createEvent } from 'effector'
import { PreloadingFlow } from '@store/system/types'

export const changePreloadingFlow = createEvent<PreloadingFlow>()
export const toggleCornerMode = createEvent<boolean | void>()
export const toggleOnline = createEvent<boolean>()

window.addEventListener('online', () => toggleOnline(true))
window.addEventListener('offline', () => toggleOnline(false))
